import { useContext } from "react";
import ItemsContext from "@@contexts/ItemsContext";

const useItemsContext = () => useContext(ItemsContext);

export default useItemsContext;
